import React, { Component, PropTypes } from 'react';
import AppStore from './AppStore';

export default class Footer extends Component {

    constructor (props) {
        super(props);
        this.state = {
            year: new Date().getFullYear()
        };
    }

    render () {
        return (
            <footer className="footer">
              <div className="container">
                <a href="http://www.lieslandco.com/" className="liesl-co-icon"></a>
                <p>Brought to you by <br />
                    <a href="http://www.lieslandco.com/">Liesl + Co.</a> &copy; {this.state.year}
                </p>
                
              </div>
            </footer>
        );
    }
}

Footer.propTypes = {
    lang: PropTypes.string.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/